import { Box} from "@mui/material";
import { FC, useState } from "react";
import {useLocation } from "react-router-dom"
import GSTransactionDetail from "../../components/GSTransactionDetail";
import MFTransactionDetail from "../../components/MFTransactionDetail";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import {
  transactionNameList,
  MFtransactionNameList,
} from "../../components/TransactionNameList";
const TransactionDeatils: FC = () => {
  let routeData = useLocation();
  const { data, status, screenname } = routeData.state;
  const [loading, setLoading] = useState(false);

  let timestamp = data?.transactionTime;
  let date = new Date(timestamp);
  let transactionDate = moment(date).format("DD MMM YYYY");
  let transactionTime = moment(date).format("hh:mm a");

  let mftimestamp = data?.created_at;
  let mfdate = new Date(mftimestamp);
  let mftransactionDate = moment(mfdate).format("DD MMM YYYY");
  let mftransactionTime = moment(mfdate).format("hh:mm a");
  const transactionDateTime = {
    transactionDate: transactionDate,
    transactionTime: transactionTime,
  };
  const MFtransactiondateTime = {
    transactionDate: mftransactionDate,
    transactionTime: mftransactionTime,
  };
  return (
    <>
      {loading ? (
        <Box
          height="100%"
          display="flex"
          flexDirection="column"
          sx={{ display: "flex", alignItems: "center", mt: 20, mb: 40 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          {screenname === "goldsilver" ? (
            <GSTransactionDetail
              item={data}
              status={status}
              type="transaction"
              data={transactionNameList(data, transactionDateTime)}
            />
          ) : (
            <MFTransactionDetail
              item={data}
              status={status}
              type="transaction"
              data={MFtransactionNameList(data, MFtransactiondateTime)}
            />
          )}
        </>
      )}
    </>
  );
};

export default TransactionDeatils;
